<template>
  <div
    v-bind:class="[pointerClass]"
    v-on:click="cardClick"
  >
    <div class="content" style="padding: 0.7em 0.7em">
      <div class="header time">
        <span
          ><i
            style="font-size: 10px; display: none"
            class="check icon green"
          ></i></span
        >{{ time }}
      </div>
      <div
        class="meta"
        style="text-decoration: line-through"
        v-if="typePaid === 2 && isAdmin == false"
      >
        {{ priceGlobal }} USD
      </div>
      <div class="meta" v-if="typePaid !== 1">{{ total }}{{ mnd }}</div>
      <div class="description">
        <h4 class="total" v-if="typePaid !== 1">
          <a style="font-size: 10px">
            {{ players }}x{{ price }} {{ mnd }}</a
          >
        </h4>
        <span
          v-if="privado || reservados >= personLimit || disponible < players"
          class="disponibilidad unavailable"
          >Unavailable</span
        >
        <span v-else class="disponibilidad available"
          >{{ disponible }} Available</span
        >
      </div>
    </div>
  </div>
</template>

<style >
.pt-card :hover {
  box-shadow: 0 1px 3px 0 #009688, 0 0 0 1px #009688 !important;
}

.pt-card .content :hover {
  box-shadow: none !important;
}

.cardActive {
  box-shadow: 0 1px 3px 0 #009688, 0 0 0 1px #009688 !important;
}
.cardActive i {
  display: inherit !important;
}
.disponibilidad {
  font-size: 11px;
}
.unavailable {
  color: red;
}
.available {
  color: #009688;
}
.time {
  font-size: 14px !important;
}
.meta {
  font-size: 12px !important;
}
.total {
  margin: 0;
  font-size: 12px !important;
}
.description {
  margin-top: 0px !important;
}

.cardEnable {
  cursor: pointer;
}

.noShow {
  display: none !important;
}

.cardPrefered {
  cursor: pointer;
  box-shadow: 0 1px 3px 0 #21ba45, 0 0 0 1px #21ba45 !important;
  background: #00b5ad5e !important;
}

.cardDisabled {
  cursor: not-allowed !important;
  background: #607d8b59 !important;
  pointer-events: none;
}
</style>


<script>
//const $ = require('jquery');
//window.$ = $;

import moment from "moment";

export default {
  name: "timeCard",
  components: {},
  props: [
    "time",
    "mnd",
    "price",
    "tarifaDocId",
    "players",
    "privado",
    "reservados",
    "prefered",
    "tarifaId",
    "priceGlobal",
    "isAdmin",
    "selectedDate",
  ],
  data() {
    return {
      clicked: false,
      personLimit: 4,
      actualDate: moment(),
    };
  },
  methods: {
    init() {},
    cardClick() {
      //this.clicked = true;
      let isPrefered = this.prefered;
      this.$emit(
        "clicked",
        this.$vnode.key,
        this.time,
        this.tarifaDocId,
        isPrefered
      );
      this.$store.commit("setPriceSelected", this.total);
      this.$store.commit("setMndSelected", this.mnd);
    },
  },
  computed: {
    total: function () {
      let total = this.price * this.players;
      if (total == 0) {
        total = "-";
      }
      return total;
    },
    disponible: function () {
      let disponible = this.personLimit - this.reservados;
      return disponible;
    },
    pointerClass: function () {
      let pointer = "cardEnable";
      if (
        this.privado ||
        this.reservados >= this.personLimit ||
        this.disponible < this.players
      ) {
        pointer = "cardDisabled";
      } else if (this.prefered == true) {
        pointer = "cardPrefered";
      }

      if (
        this.actualDate.format("YYYY-MM-DD HH:mm") >
        moment(
          this.selectedDate.format("YYYY-MM-DD") + this.time,
          "YYYY-MM-DD HH:mm"
        ).format("YYYY-MM-DD HH:mm")
      ) {
        //this.$pgsHelper.log(this.actualDate.format('YYYY-MM-DD HH:mm'));

        pointer = "noShow";
      }

      return pointer;
    },
    typePaid() {
      return this.$store.getters.getTypePaid;
    },
    globalPrice() {
      return this.$store.getters.getGlobalPrice;
    },
  },
  watch: {},
  mounted() {
    this.init();
  },
  created() {
    setInterval(() => {
      let fecha = new moment();
      this.actualDate = fecha; //.format("YYYY-MM-DD HH:mm:ss");
    }, 1000);
  },
};
</script>